import React, { Component } from 'react';
import './Contactus.scss';
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/Footer';
import { contactUs } from '../../global/texts/Contactus';
import Button from '../../components/Button/Button';
import ChatIcon from '../../Assets/images/ContactUs/group-10.svg';
import NoIcon from '../../Assets/images/ContactUs/group-3.svg';
import EmailIcon from '../../Assets/images/ContactUs/group-4.svg';
import ReachIcon from '../../Assets/images/ContactUs/group-105.svg';
// import { pushTrackingEventsToGAAndFB } from '../../global/commonFunctions/GaAndFb';
import { Helmet } from 'react-helmet';
import { seoData } from '../../global/seoData';
import { altText } from '../../global/altText';
import { globalVal } from '../../global/globalvalues';

type initialProps = {
    history: any;
};

type initialState = {};

export class Contactus extends Component<initialProps, initialState> {
    componentDidMount() {
        window.scroll(0, 0);
    }
    visitHelpCenterHandler = (e: any) => {
        // pushTrackingEventsToGAAndFB(
        //     {
        //         category: 'Contact Us',
        //         actionType: 'Visit Help Center',
        //     },
        //     e,
        // );
        console.log(e)
        window.open(`${contactUs && contactUs.button && contactUs.button.link}`, '_blank');
    };
    chatWithUS = (e: any) => {
        // pushTrackingEventsToGAAndFB(
        //     {
        //         category: 'Contact Us',
        //         actionType: 'Chat With Us',
        //     },
        //     e,
        // );
        console.log(e)
    };
    formatPhoneNumber = (phone: string) => {
        var cleaned = ('' + phone).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = match[1] ? '+1 ' : '';
            return [intlCode, '(', match[2], ')', match[3], '-', match[4]].join('');
        }
        return null;
    };
    phoneHandler = (e: any) => {
        // pushTrackingEventsToGAAndFB(
        //     {
        //         category: 'Contact Us',
        //         actionType: 'Phone Number',
        //     },
        //     e,
        // );
        console.log(e)
    };
    emailHandler = (e: any) => {
        // pushTrackingEventsToGAAndFB(
        //     {
        //         category: 'Contact Us',
        //         actionType: 'Email Reach',
        //     },

        //     e,
        // );
        console.log(e)
    };
    render() {
        return (
            <div className="ContactusMain">
                <Helmet>
                    <title>{seoData.contactUs.title}</title>
                    <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                    <meta property="og:title" name="title" content={seoData.contactUs.title} />
                    <meta property="og:description" name="description" content={seoData.contactUs.description} />
                    <meta name="keywords" content={seoData.contactUs.keywords} />
                    <meta name="description" content={seoData.contactUs.description} />
                    <meta name="robots" content="index, follow" />
                </Helmet>

                <Header history={this.props.history} />
                <div className="mediaQueriesContactus">
                    <div className="ContactContent">
                        <h1 className="ContactTitle">{contactUs && contactUs.contactHeading}</h1>
                        <div className="ContactLine"></div>

                        <div className="ContactAndHelpCenter">
                            <div className="ContactHelpCenter">
                                <div className="ContactHpHeading">{contactUs && contactUs.contactHpHeading}</div>
                                <div className="ContactHpContent">{contactUs && contactUs.helpCenter}</div>
                                <div className="ContactHpButton">
                                    <Button primary={false} onClick={(e: any) => this.visitHelpCenterHandler(e)}>
                                        {contactUs && contactUs.button && contactUs.button.text}
                                    </Button>
                                </div>
                            </div>
                            <div className="ContactHelpCenter">
                                <div className="ContactHpHeading ">
                                    {contactUs && contactUs.contactHpHeadingSupport}
                                </div>
                                <div className="ContactSupportChatNo">
                                    <div className="ContactSupport">
                                        <img className="IconMargin" alt="" src={ChatIcon}></img>
                                        <a className="ContactSupport" href="#hs-chat-open" rel="noopener noreferrer">
                                            {contactUs && contactUs.chat}
                                        </a>

                                        {/* <span  onClick={this.chatWithUS}>
                                            {contactUs && contactUs.chat}
                                        </span> */}
                                    </div>
                                    <div className="ContactSupport">
                                        <img className="IconMargin" alt="" src={NoIcon}></img>

                                        <span onClick={this.phoneHandler}>
                                            <a href={`tel:${contactUs && contactUs.contactNo}`}>
                                                {this.formatPhoneNumber(contactUs && contactUs.contactNo)}
                                            </a>
                                        </span>
                                        <div className="supportTime">9:00 AM to 5:00 PM EST (Monday to Friday)</div>
                                    </div>
                                </div>
                                <div className="ContactSupport">
                                    <img className="IconMargin" alt={altText.contactUs.sendEmail} src={EmailIcon}></img>
                                    <span onClick={this.emailHandler}>
                                        <a href={`mailto:${contactUs && contactUs.email}`}>
                                            {contactUs && contactUs.email}
                                        </a>
                                    </span>
                                </div>
                                <div className="ContactHpHeading ContactOurPartner">
                                    {contactUs && contactUs.contactHpHeadingPartner}
                                </div>
                                <div className="ContactSupportChatNo">
                                    <div className="ContactSupport">
                                        <img
                                            className="IconMargin"
                                            alt={altText.contactUs.sendEmail}
                                            src={EmailIcon}
                                        ></img>
                                        <span onClick={this.emailHandler}>
                                            <a href={`mailto:${contactUs && contactUs.partners}`}>
                                                {contactUs && contactUs.partners}
                                            </a>
                                        </span>
                                    </div>
                                    <div className="ContactSupport">
                                        <img
                                            className="IconMargin"
                                            alt={altText.contactUs.sendEmail}
                                            src={EmailIcon}
                                        ></img>
                                        <span onClick={this.emailHandler}>
                                            <a href={`mailto:${contactUs && contactUs.partners1}`}>
                                                {contactUs && contactUs.partners1}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="ContactAddress">
                            <img alt="" className="ReachClass" src={ReachIcon}></img>
                            <div
                                className="ContactAddressText"
                                dangerouslySetInnerHTML={{
                                    __html: contactUs && contactUs.address,
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
                <Footer isFixed={true} />
            </div>
        );
    }
}

export default Contactus;
